module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_1.2b272d54.pdf";